import {
  DeleteHiringPhaseDocument,
  DeleteHiringPhaseMutation,
  DeleteHiringPhaseMutationVariables,
  GetHiringStagesDocument,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export const useDeleteHiringPhase = () => {
  const [deleteAtsHiringPhase, { loading }] = useMutation(DeleteHiringPhaseDocument, {
    extractorFn: (data: DeleteHiringPhaseMutation) => data.atsMutations.deleteAtsHiringPhase,
  })

  return {
    loading,
    deleteAtsHiringPhase(variables: DeleteHiringPhaseMutationVariables) {
      return deleteAtsHiringPhase({
        variables: variables,
        refetchQueries: [GetHiringStagesDocument],
      })
    },
  }
}
